
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/accessories",
      function () {
        return require("private-next-pages/pvc/accessories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/accessories"])
      });
    }
  